/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Job_AddedInputs */

const en_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job added`)
};

const de_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle hinzugefügt`)
};

const fr_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi ajouté`)
};

const es_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo añadido`)
};

const it_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro aggiunto`)
};

const nl_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baangelegenheid toegevoegd`)
};

const pl_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodano pracę`)
};

const fi_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikka lisätty`)
};

const da_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job tilføjet`)
};

const sv_common_job_added = /** @type {(inputs: Common_Job_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb tillagt`)
};

/**
* | output |
* | --- |
* | "Job added" |
*
* @param {Common_Job_AddedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_job_added = /** @type {((inputs?: Common_Job_AddedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Job_AddedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_job_added(inputs)
	if (locale === "fr") return fr_common_job_added(inputs)
	if (locale === "es") return es_common_job_added(inputs)
	if (locale === "it") return it_common_job_added(inputs)
	if (locale === "nl") return nl_common_job_added(inputs)
	if (locale === "pl") return pl_common_job_added(inputs)
	if (locale === "fi") return fi_common_job_added(inputs)
	if (locale === "da") return da_common_job_added(inputs)
	if (locale === "sv") return sv_common_job_added(inputs)
	return en_common_job_added(inputs)
});